import type { JSX } from 'react';
import { FormSection } from '@ksyos/design-system';
import { ProcessActivityAssetsDropzone } from '../../processActivityAssets/ProcessActivityAssetsDropzone';
import { TextAreaFormGroup } from '../../processActivityFormGroupFields';

export function BariPreMedConsultExamResultsEdit(): JSX.Element {
    return (
        <>
            <FormSection>
                <ProcessActivityAssetsDropzone
                    errorText="Voeg alsjeblieft bestanden met uitslagen toe"
                    isRequired={true}
                    label="Bestand(en) met uitslagen"
                />
            </FormSection>

            <FormSection>
                <TextAreaFormGroup
                    fieldKey="toelichting"
                    isRequired={true}
                    label="Toelichting"
                    placeholder="Typ je toelichting of opmerking..."
                />
            </FormSection>
        </>
    );
}
